import { difference, keys } from "lodash-es";

const defaultState = () => {
	return {
		reports: {
			count: 0,
			results: [],
		},
		report: {
			name: null,
			tokenId: null,
			accessToken: null,
			reportConfig: [],
			is_favorite: false,
		},
		reportValid: false,
	};
};

const state = {
	reports: defaultState().reports,
	report: defaultState().report,
	reportValid: defaultState().reportValid,
};

const getters = {
	reports: (state) => {
		return state.reports;
	},
	report: (state) => {
		return state.report;
	},
	reportValid: (state) => {
		return state.reportValid;
	},
};

const actions = {};

const mutations = {
	GET_REPORTS: (state, payload) => {
		if (payload) {
			state.reports.count += payload.results
				? payload.results.length
				: payload.data.length;
			state.reports.results = state.reports.results.concat(
				payload.results || payload.data
			);
		} else {
			state.reports = defaultState().reports;
		}
	},
	READ_REPORT: (state, payload) => {
		if (payload) {
			state.report =
				"string" === typeof payload.data
					? JSON.parse(payload.data)
					: payload.data;
		} else {
			state.report = defaultState().report;
		}
	},
	UPDATE_REPORT: (state, payload) => {
		const index = state.reports.results.findIndex(
			(item) => item.id == payload.data.id
		);

		if (0 <= index) {
			const diff = difference(
				keys(state.reports.results[index]),
				keys(payload.data)
			);

			if (0 < diff.length)
				diff.forEach((item) => {
					payload.data[item] = state.reports.results[index][item];
				});

			state.reports.results.splice(index, 1, payload.data);
		}
	},
	DELETE_REPORT: (state, payload) => {
		const index = state.reports.results.findIndex(
			(item) => item.id == payload.data.id
		);

		if (0 <= index) {
			state.reports.count -= 1;
			state.reports.results.splice(index, 1);
		}
	},
	ASSIGN_REPORT_ACCESS: (state, payload) => {
		if (0 < payload.length) {
			state.reports.count += payload.length;
			state.reports.results = state.reports.results.concat(payload);
		}
	},
	UNASSIGN_REPORT_ACCESS: (state, payload) => {
		const index = state.reports.results.findIndex(
			(item) => item.id == payload.data.id
		);

		if (0 <= index) {
			state.reports.count -= 1;
			state.reports.results.splice(index, 1);
		}
	},
	FAVORITE_REPORT: (state, payload) => {
		state.report = {
			is_favorite: "remove" === payload ? false : true,
		};
	},
	VALIDATE_REPORT: (state, validity) => {
		state.reportValid = validity;
	},
};

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations,
};
